function viewMore(){
  var x = document.getElementById("show-more");
  var additional_Text = document.getElementById('additional_text');
  if (x.style.display === "none") {
    x.style.display = "block";
    additional_Text.style.display = "none";
    document.getElementById("btn-text").innerHTML = "Read Less";
  } else {
    additional_Text.style.display = "inline-block";
    x.style.display = "none";
    document.getElementById("btn-text").innerHTML = "Read More";
  }
}